import { render, staticRenderFns } from "./Indicator.vue?vue&type=template&id=ef4ad04e&scoped=true"
import script from "./Indicator.vue?vue&type=script&lang=js"
export * from "./Indicator.vue?vue&type=script&lang=js"
import style0 from "./Indicator.vue?vue&type=style&index=0&id=ef4ad04e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4ad04e",
  null
  
)

export default component.exports